import { trpc } from "@/Utils/trpc";
import { LogoTile } from "@/components/LogoTile";

import { useCallback } from "react";

type Props = {
  displayName: string;
  namespace: string;
  size?: number;
};

export const SiteLogoView: React.FC<Props> = ({
  displayName,
  namespace,
  size = 30,
}) => {
  const trpcUtils = trpc.useUtils();

  const {
    data: logoData,
    refetch,
    isLoading,
  } = trpc.siteStorage.getLogo.useQuery({ namespace });

  const { mutate: deleteLogoFromStorage } =
    trpc.siteStorage.deleteLogo.useMutation();

  const getUploadUrl = useCallback(
    async (filename: string) => {
      return trpcUtils.siteStorage.getUploadUrl.fetch({
        filename,
        namespace,
      });
    },
    [trpcUtils, namespace],
  );

  const { mutateAsync: cleanUpLogoFilesMutation } =
    trpc.siteStorage.cleanUpLogoFiles.useMutation();

  const cleanUpLogoFiles = useCallback(
    async (oldFileName: string) => {
      await cleanUpLogoFilesMutation({ oldFileName, namespace });
    },
    [cleanUpLogoFilesMutation, namespace],
  );

  const deleteLogo = useCallback(
    (fileName: string, options: { onSuccess: () => void }) => {
      deleteLogoFromStorage(
        { fileName, namespace },
        { onSuccess: options.onSuccess },
      );
    },
    [deleteLogoFromStorage, namespace],
  );

  if (isLoading) {
    return <div className="h-[48px] w-[48px] rounded-md bg-neutral-100" />;
  }

  return (
    <div className="relative">
      <LogoTile
        logoUrl={logoData?.url ?? null}
        displayName={displayName || "?"}
        size={size}
        variant="clipped"
        enableFileMenu
        buttonPosition="left"
        uploadConfig={{
          getUploadUrl,
          cleanUpLogoFiles,
          deleteLogo,
          onComplete: refetch,
          currentFileName: logoData?.name,
        }}
      />
    </div>
  );
};
